
export const pdfPrevMap = {
  path: '/pdfPrev',
  component: () => import('@/views/teachingProtection/assessment/assessment/pdfPrev.vue'),
  meta: { hidden: true }
}
